export interface ActionItem {
  id: string;
  title: string;
  icon: string;
}
